import type { RouteRecordRaw } from 'vue-router';
import md from '@/router/middlewares';
import store from '@/store';
import { crmRoutes } from '@/crm/src';

// `src/crm` ships `crmRoutes` without `meta.middlewares` on purpose (the submodule does not own
// `@/router/middlewares`) — the shell attaches the standard auth + role chain here.

const crm: RouteRecordRaw = {
    ...crmRoutes,
    meta: {
        ...crmRoutes.meta,
        middlewares: [md.auth, md.accessControl],
    },
    beforeEnter: async (_to, _from, next) => {
        if (!store.getters.showCrmByFeature) {
            const teamId = store.getters.currentTeamId || window.$cookies?.get('currentTeamId');
            if (teamId) {
                await store.dispatch('reloadTeam', teamId);
            }
        }
        if (!store.getters.showCrmByFeature) {
            next({ name: 'clients' });
        } else {
            next();
        }
    },
};

export default crm;
